import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=5e2cf2a0&scoped=true&"
import script from "./Submenu.vue?vue&type=script&lang=js&"
export * from "./Submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2cf2a0",
  null
  
)

export default component.exports